// eslint-disable-next-line max-classes-per-file
import { Type } from 'class-transformer';
import {
  IsArray,
  IsDateString,
  IsNotEmpty,
  IsOptional,
  IsString,
  ValidateNested,
} from 'class-validator';

const notEmptyOptions = {
  message: 'Обязательное поле',
  groups: ['form'],
};

class EditVacationApproverDeadlineDto {
  @IsDateString()
  @IsNotEmpty(notEmptyOptions)
  deadline: string;
}

export class EditVacationDeadlinesDto {
  @IsDateString()
  @IsNotEmpty(notEmptyOptions)
  activeTo: string;

  @IsDateString()
  @IsNotEmpty(notEmptyOptions)
  employeeDeadline: string;

  @ValidateNested({ each: true })
  @Type(() => EditVacationApproverDeadlineDto)
  @IsArray()
  @IsOptional()
  approvers?: EditVacationApproverDeadlineDto[];

  @IsString()
  @IsOptional()
  hasThresholdPercent?: string;

  @IsString()
  @IsOptional()
  thresholdPercent?: string;

  @IsString()
  @IsOptional()
  customName?: string;
}
